import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { UnitType } from '../../../../../models/enums/unit-type.enum';
import { MeasurementService } from '../../../../../services/measurement.service';

@Component({
    selector: 'app-y',
    templateUrl: './y.component.html',
    styleUrls: ['./y.component.scss'],
    standalone: false
})
export class YComponent implements OnInit {
    @Input() form: UntypedFormGroup;
    tooltip_position = 'above';

    constructor(private measSvc: MeasurementService) {}

    ngOnInit(): void {
        this.form
            .get('y')
            .valueChanges.subscribe((value) => this.form.get('y').patchValue(this.measSvc.format(value, UnitType.DefaultStressUnit), { emitEvent: false }));
    }
}
